import axios from 'axios';
import { API_DOMAIN } from '../../../components/constants';
import { authHeaders } from '../../../components/qv4/models/shared/apiClient';
import { labels, paths } from './attendance';
export const dayStatuses = { working: 'Working', off: 'Day off', holiday: 'Holiday', untracked: 'Not tracked' };
export const liveStates = { ...labels, not_started: 'Not started', absent: 'Absent' };
export const attentionLabels = { break_overrun: 'Break overrun', over_allowance: 'Over allowance', unmarked_long: 'Idle/disconnected too long', not_started: 'Not started yet' };
export const absenceStatuses = { undecided: 'Absence — undecided', paid_leave: 'Paid leave', sick_leave: 'Sick leave', unpaid_leave: 'Unpaid leave', approved_day_off: 'Approved day off', unexcused: 'Unexcused absence' };
export const exportStatuses = { queued: 'Queued', running: 'Running', ready: 'Ready', failed: 'Failed', expired: 'Expired' };
export const validExportResult = row => Boolean(Number.isInteger(row?.export_id) && row.export_id > 0 && exportStatuses[row.status]);
export const flagLabels = { auto_closed: 'Automatically closed', capped: 'Session limit reached', corrected: 'Corrected', off_schedule: 'Outside schedule', locked: 'Locked', has_undecided_items: 'Undecided items', over_allowance: 'Over allowance' };
export function rangeDays(from, to) {
  const valid = value => /^\d{4}-\d{2}-\d{2}$/.test(value || '') && Number.isFinite(Date.parse(value)) && new Date(value).toISOString().slice(0, 10) === value;
  if (!valid(from) || !valid(to)) return 0;
  const days = (Date.parse(to) - Date.parse(from)) / 86400000 + 1;
  return days > 0 ? days : 0;
}
export const lateLabel = value => value == null ? '—' : `${value.minutes}m${value.beyond_tolerance ? ' · beyond tolerance' : ''}`;
export const percentLabel = value => value == null ? '—' : `${value}%`;
export function exportFileName(headers, fallback) {
  const disposition = headers?.get?.('content-disposition') || headers?.['content-disposition'] || headers?.['Content-Disposition'] || '';
  const encoded = disposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i), plain = disposition.match(/filename\s*=\s*(?:"([^"]+)"|([^;]+))/i);
  let name = plain?.[1] || plain?.[2];
  if (encoded) { try { name = decodeURIComponent(encoded[1].trim()); } catch (_) {} }
  return [...(name || fallback).trim().split(/[\\/]/).pop()].map(char => char.charCodeAt(0) < 32 || '<>:"|?*'.includes(char) ? '_' : char).join('') || fallback;
}
// The same authenticated transport accepts direct bytes or the queued envelope.
async function bodyOf(data) { return data instanceof Blob ? JSON.parse(await data.text()) : data; }
async function binaryResponse(request) {
  try {
    const response = await request(), type = response.headers?.['content-type'] || response.data?.type || '';
    if (!type.includes('json')) return { file: response.data, headers: response.headers };
    const body = await bodyOf(response.data);
    if (!body.success) throw Object.assign(new Error(body.message), { code: body.code, data: body.data, status: response.status });
    return { export: body.data };
  } catch (error) {
    if (error.response) { let body; try { body = await bodyOf(error.response.data); } catch (_) {} Object.assign(error, { status: error.response.status, code: body?.code || error.code, data: body?.data }); }
    throw error;
  }
}
export function exportRequest(body, key) {
  const frozen = JSON.parse(JSON.stringify({ ...body, idempotency_key: key }));
  return () => binaryResponse(() => axios.post(`${API_DOMAIN}${paths.reportExport}`, frozen, { ...authHeaders(), responseType: 'blob' }));
}
export const downloadExport = id => binaryResponse(() => axios.get(`${API_DOMAIN}${paths.reportExportFile(id)}`, { ...authHeaders(), responseType: 'blob' }));
export function saveExportFile(file, headers, fallback) {
  const url = URL.createObjectURL(file), anchor = document.createElement('a');
  try { anchor.href = url; anchor.download = exportFileName(headers, fallback); document.body.appendChild(anchor); anchor.click(); }
  finally { anchor.remove(); setTimeout(() => URL.revokeObjectURL(url), 0); }
}
